<mj-record-form-container [Record]="record" [FormComponent]="this"
    (Navigate)="OnFormNavigate($event)"
    (DeleteRequested)="OnDeleteRequested()"
    (FavoriteToggled)="OnFavoriteToggled()"
    (HistoryRequested)="OnHistoryRequested()"
    (ListManagementRequested)="OnListManagementRequested()">

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="before-fields" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>

    <!-- ========================================
         FIELD PANELS
         ======================================== -->
    <!-- Details Section -->
    <mj-collapsible-panel
        SectionKey="details"
        SectionName="Details"
        Icon="fa fa-align-left"
        [Form]="this"
        [FormContext]="formContext">
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ProcessingBatchID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="Record"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="RecordID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ErrorType"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ErrorCode"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ErrorMessage"
            Type="textarea"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="FieldName"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="FieldValue"
            Type="textarea"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="SourceData"
            Type="textarea"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ErrorDate"
            Type="datepicker"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="IsResolved"
            Type="checkbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ResolvedDate"
            Type="datepicker"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ResolvedBy"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Resolution"
            Type="textarea"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_CreatedAt"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_UpdatedAt"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="CompanyID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="Record"
        ></mj-form-field>

    </mj-collapsible-panel>

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="after-fields" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="after-related" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>
</mj-record-form-container>
        